import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateAccessPassCommand,
  FilterAccessPassesCommand,
  ValidateAccessPassInBuildingCommand,
} from './access-pass.commands';
import { CreatedAccessPassEvent, FilteredAccessPassesDomainEvent } from './access-pass.events';

@Injectable()
export class AccessPassEffects {
  prefix = 'access-pass';
  createAccessPassCommand: Observable<Action<string>> & CreateEffectMetadata;
  filterAccessPassesCommand: Observable<Action<string>> & CreateEffectMetadata;
  validateAccessPassInBuildingCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createAccessPassCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateAccessPassCommand,
      CreatedAccessPassEvent,
      this.prefix,
    );

    this.filterAccessPassesCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: FilterAccessPassesCommand,
      prefix: this.prefix,

      others: (httpResponse: any, commandData: any) => {
        const data = httpResponse.data;
        return [
          FilteredAccessPassesDomainEvent({ data: data, transactionId: commandData.transactionId }),
        ];
      },
    });

    this.validateAccessPassInBuildingCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: ValidateAccessPassInBuildingCommand,
      prefix: this.prefix,
    });
  }
}
